import {
    Divider,
    Flex,
    IconButton,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useTheme,
} from '@chakra-ui/react';
import ActClose from '../../../../canopy-ui-components/components/Icons/ActClose';
import { useCurrentColors } from '../../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';

const DownloadUnavailableModal = ({
    openModal,
    setOpenModal,
    onClose,
    t,
}: any) => {
    const currentColors = useCurrentColors();
    const theme = useTheme();
    const logo = theme?.images?.headerLogo;

    return (
        <Modal
            isCentered
            closeOnOverlayClick={false}
            onEsc={() => setOpenModal(false)}
            isOpen={openModal}
            size="6xl"
            onClose={onClose}
        >
            <ModalOverlay
                style={{
                    backdropFilter: 'blur(5px)',
                }}
            />
            <ModalContent>
                <ModalHeader
                    color={currentColors.brand['10']}
                    fontSize="20px"
                    fontWeight="bold"
                    padding="15px"
                >
                    <Flex alignItems="center">
                        <Image
                            src={logo}
                            maxWidth="100%"
                            width="auto"
                            height={'35px'}
                            mr="17.5px"
                        />
                        <Text width="100%">
                            {t('document-unavaible-for-download')}
                        </Text>
                    </Flex>
                    <Divider
                        borderColor={currentColors.brand['700']}
                        width="100%"
                        mb="0px"
                    />
                </ModalHeader>
                <ModalCloseButton
                    as={() => (
                        <IconButton
                            background="transparent"
                            cursor="pointer"
                            border="none"
                            display="inline-flex"
                            onClick={onClose}
                            color={currentColors.brand['500']}
                            width="24px"
                            height="24px"
                            aria-label="remove"
                            icon={<ActClose />}
                            variant="ghost"
                            position="absolute"
                            top="15px"
                            right="15px"
                        />
                    )}
                />
                <ModalBody
                    padding="15px"
                    maxHeight={'60vh'}
                    overflow="auto"
                >
                    <Flex padding="0 15px">
                        <Text
                            width="100%"
                            dangerouslySetInnerHTML={{
                                __html: t(
                                    'document-unavaible-for-download-details',
                                    {
                                        interpolation: {
                                            escapeValue: false,
                                        },
                                    }
                                ),
                            }}
                        ></Text>
                    </Flex>
                </ModalBody>
                <ModalFooter
                    color={currentColors.brand['10']}
                    fontSize="20px"
                    fontWeight="bold"
                    padding="15px"
                >
                    <Divider
                        borderColor={currentColors.brand['700']}
                        width="100%"
                        mt="0px"
                    />
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DownloadUnavailableModal;
